// @ts-nocheck
// ====== Riferimenti interni (rubrica + aggregato) ======
// Due tabelle nella vista PM:
//   1) Rubrica persone interne (CRUD su tabella persone_interne)
//   2) Aggregato CPL/PM1/PM2 dai clienti (read-only, con bridge alla rubrica)
//
// Il bridge: una persona presente nei clienti (anche solo come testo libero
// nei campi cpl/pm1/pm2) che non è ancora in rubrica mostra un bottone
// "Aggiungi alla rubrica" per crearla con un click.

const SOVRACCARICO_SOGLIA = 10;

function rubricaIndex() {
  const map = new Map();
  (state?.persone || []).forEach((p) => {
    if (p?.nome) map.set(p.nome.toLowerCase(), p);
  });
  return map;
}

function renderRubrica() {
  const tbody = document.getElementById('tbodyPersone');
  const countEl = document.getElementById('rubricaCount');
  if (!tbody) return;
  const persone = (state?.persone || []).slice().sort((a, b) => a.nome.localeCompare(b.nome));
  if (countEl) {
    countEl.textContent = persone.length
      ? `${persone.length} person${persone.length === 1 ? 'a' : 'e'} in rubrica`
      : 'Rubrica vuota';
  }
  if (!persone.length) {
    tbody.innerHTML =
      '<tr><td colspan="5" style="text-align:center;padding:20px;color:var(--text-muted)">Rubrica vuota. Aggiungi la prima persona con il bottone qui sopra, oppure dalla tabella "Conteggi" sotto (link "Aggiungi alla rubrica").</td></tr>';
    return;
  }
  tbody.innerHTML = persone
    .map(
      (p) => `
      <tr data-pid="${escapeHtml(p.id)}">
        <td data-label="Nome"><strong>${escapeHtml(p.nome)}</strong></td>
        <td data-label="Email">${p.email ? `<a href="mailto:${escapeHtml(p.email)}">${escapeHtml(p.email)}</a>` : '<span class="muted">—</span>'}</td>
        <td data-label="Ruolo">${p.ruolo ? `<span class="role-pill role-cpl">${escapeHtml(p.ruolo)}</span>` : '<span class="muted">—</span>'}</td>
        <td data-label="Note" class="muted" style="font-size:12px;">${escapeHtml(p.note || '')}</td>
        <td class="user-actions">
          <button class="btn btn-sm" data-persona-edit="${escapeHtml(p.id)}">Modifica</button>
          <button class="btn btn-sm btn-danger" data-persona-del="${escapeHtml(p.id)}" data-name="${escapeHtml(p.nome)}">Rimuovi</button>
        </td>
      </tr>`
    )
    .join('');
  tbody.querySelectorAll('[data-persona-edit]').forEach((b) => {
    b.addEventListener('click', () => openPersonaModal(b.dataset.personaEdit));
  });
  tbody.querySelectorAll('[data-persona-del]').forEach((b) => {
    b.addEventListener('click', () => deletePersona(b.dataset.personaDel, b.dataset.name));
  });
}

function renderPM() {
  renderRubrica();

  const tbody = $('#tbodyPM');
  const thead = document.querySelector('#view-pm thead');
  if (!tbody) return;
  const map = {};
  function bump(person, role, c) {
    if (!person) return;
    if (!map[person]) map[person] = { cpl: 0, pm1: 0, pm2: 0, clienti: new Set(), azioni: 0 };
    map[person][role]++;
    map[person].clienti.add(c.nome);
  }
  state.clients.forEach((c) => {
    bump(c.cpl, 'cpl', c);
    bump(c.pm1, 'pm1', c);
    bump(c.pm2, 'pm2', c);
  });

  collectActions().forEach((a) => {
    if (a.cpl && map[a.cpl]) map[a.cpl].azioni++;
  });

  const hasPm1 = state.clients.some((c) => c.pm1 && c.pm1.trim());
  const hasPm2 = state.clients.some((c) => c.pm2 && c.pm2.trim());
  if (thead) {
    const headers = thead.querySelectorAll('th');
    if (headers[2]) headers[2].style.display = hasPm1 ? '' : 'none';
    if (headers[3]) headers[3].style.display = hasPm2 ? '' : 'none';
  }

  const idx = rubricaIndex();
  const rows = Object.entries(map).sort((a, b) => b[1].clienti.size - a[1].clienti.size);
  tbody.innerHTML = rows.length
    ? rows
        .map(([person, v]) => {
          const sovraccarico = v.clienti.size > SOVRACCARICO_SOGLIA;
          const inRubrica = idx.get(person.toLowerCase());
          const rubricaCell = inRubrica
            ? `<span class="status status-si" title="In rubrica${inRubrica.email ? ' · ' + inRubrica.email : ''}">In rubrica</span>`
            : isAdmin()
              ? `<button class="btn btn-sm" data-add-to-rubrica="${escapeHtml(person)}">+ Aggiungi alla rubrica</button>`
              : '<span class="muted">—</span>';
          return `
            <tr>
              <td>
                <strong>${escapeHtml(person)}</strong>
                ${sovraccarico ? '<span class="overload-badge" title="Più di ' + SOVRACCARICO_SOGLIA + ' clienti gestiti">Sovraccarico</span>' : ''}
              </td>
              <td>${v.cpl ? `<span class="role-pill role-cpl">${v.cpl}</span>` : '—'}</td>
              <td${hasPm1 ? '' : ' style="display:none;"'}>${v.pm1 ? `<span class="role-pill role-pm1">${v.pm1}</span>` : '—'}</td>
              <td${hasPm2 ? '' : ' style="display:none;"'}>${v.pm2 ? `<span class="role-pill role-pm2">${v.pm2}</span>` : '—'}</td>
              <td>${v.clienti.size}</td>
              <td>${v.azioni ? `<span class="status status-darichiedere">${v.azioni}</span>` : '<span class="muted">0</span>'}</td>
              <td>${rubricaCell}</td>
            </tr>`;
        })
        .join('')
    : '<tr><td colspan="7" style="text-align:center;padding:30px;color:var(--text-muted)">Nessun riferimento interno censito.</td></tr>';

  // Wire "Aggiungi alla rubrica"
  tbody.querySelectorAll('[data-add-to-rubrica]').forEach((b) => {
    b.addEventListener('click', () => openPersonaModal(null, { nome: b.dataset.addToRubrica }));
  });
}

// ===== Modale Persona =====
function openPersonaModal(id, prefill) {
  if (!isAdmin()) return;
  const modal = document.getElementById('modalPersona');
  if (!modal) return;
  const p = id ? (state.persone || []).find((x) => x.id === id) : null;
  const title = document.getElementById('modalPersonaTitle');
  if (title) title.textContent = p ? 'Modifica persona interna' : 'Nuova persona interna';
  const f = document.getElementById('formPersona');
  f.reset();
  f.id.value = p?.id || '';
  f.nome.value = p?.nome || prefill?.nome || '';
  f.email.value = p?.email || prefill?.email || '';
  f.ruolo.value = p?.ruolo || '';
  f.note.value = p?.note || '';
  f.active.checked = p ? p.active !== false : true;
  modal.classList.remove('hidden');
}

function closePersonaModal() {
  document.getElementById('modalPersona')?.classList.add('hidden');
}

async function submitPersona(e) {
  e.preventDefault();
  if (!isAdmin()) return;
  const f = document.getElementById('formPersona');
  const payload = {
    id: f.id.value || null,
    nome: f.nome.value.trim(),
    email: f.email.value.trim(),
    ruolo: f.ruolo.value,
    note: f.note.value.trim(),
    active: f.active.checked
  };
  if (!payload.nome) {
    toast('Nome obbligatorio');
    return;
  }
  try {
    const newId = await api.upsertPersona(payload);
    logAudit({
      action: payload.id ? 'update' : 'create',
      entity: 'Persona interna',
      target: payload.nome,
      details: payload.email ? 'Email: ' + payload.email : ''
    });
    closePersonaModal();
    await loadStateFromSupabase();
    renderPM();
    toast(payload.id ? 'Persona aggiornata' : 'Persona aggiunta alla rubrica');
    return newId;
  } catch (err) {
    console.error(err);
    if ((err.message || '').includes('persone_interne_nome_uniq')) {
      toast('Esiste già una persona con questo nome');
    } else {
      toast('Errore: ' + (err.message || err));
    }
  }
}

async function deletePersona(id, name) {
  if (!isAdmin()) return;
  const ok = await confirmAction({
    level: 'warning',
    title: 'Rimuovere persona',
    message: `Stai per rimuovere "${name || id}" dalla rubrica. I riferimenti già scritti nei clienti restano (come testo libero).`,
    confirmText: 'Rimuovi'
  });
  if (!ok) return;
  try {
    await api.deletePersona(id);
    logAudit({
      action: 'delete',
      entity: 'Persona interna',
      target: name || id,
      details: 'Rimossa dalla rubrica'
    });
    await loadStateFromSupabase();
    renderPM();
    toast('Persona rimossa');
  } catch (e) {
    console.error(e);
    toast('Errore: ' + (e.message || e));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.getElementById('btnAddPersona')?.addEventListener('click', () => openPersonaModal());
  document.getElementById('formPersona')?.addEventListener('submit', submitPersona);
  document
    .querySelectorAll('[data-close-persona]')
    .forEach((el) => el.addEventListener('click', closePersonaModal));
});

Object.assign(globalThis, {
  renderPM,
  renderRubrica,
  openPersonaModal,
  closePersonaModal,
  submitPersona,
  deletePersona
});
export {};
